module.exports = __webpack_public_path__ + "img/10.240f87f5.jpg";